export default __webpack_public_path__ + "static/media/AMZN_DE_SH_SD.67be46c6.svg";